module.exports = __webpack_public_path__ + "img/teamBg.4424aba6.jpg";